import { QueryClient } from "@tanstack/react-query";
import { broadcastQueryClient } from "@tanstack/query-broadcast-client-experimental";

export const queryClient = new QueryClient();

broadcastQueryClient({
    queryClient,
    broadcastChannel: "kick-app",
});

export function getEntityUsersQueryKey(entityId: number) {
    return ["entityUsers", entityId];
}
export function getEntityInvitesQueryKey(entityId: number) {
    return ["entityInvites", entityId];
}
export function getAddressQueryKey(entityId: number) {
    return ["address", entityId];
}
export function getPayrollQueryKey(entityId: number) {
    return ["entityPayrolls", entityId];
}

export const locksQueryKey = "locks";
export function getLockQueryKey(entityId?: number | null) {
    return [locksQueryKey, entityId];
}
export function getLocksQueryKey(entityIds: number[]) {
    return [locksQueryKey, entityIds];
}

export const financialConnectionsQueryKey = "financialConnections";
export const plaidConnectionsQueryKey = [
    financialConnectionsQueryKey,
    "plaidConnections",
];
export const stripeConnectionsQueryKey = [
    financialConnectionsQueryKey,
    "stripeConnections",
];

export const rampConnectionsQueryKey = [
    financialConnectionsQueryKey,
    "rampConnections",
];
export const gustoConnectionsQueryKey = [
    financialConnectionsQueryKey,
    "gustoConnections",
];
export const mercuryConnectionsQueryKey = [
    financialConnectionsQueryKey,
    "mercuryConnections",
];

export const allMembersQueryKey = "allMembers";
export const materialUnconfirmedTransactionsQueryKey =
    "materialUnconfirmedTransactions";

export const EMPTY_COLLECTION_QUERY_KEY = "emptyCollection";
export const EMPTY_COLLECTION = [];

export const CUSTOM_CATEGORIES_QUERY_KEY = "custom-categories";
